const manifestRoutesData = {
  login: 'login',
};

export const updateManifestPerRoute = (route) => {
  const link = document.querySelector('link[rel="manifest"]');
  const filePostfix = manifestRoutesData[route] ? `-${manifestRoutesData[route]}` : '';

  if (link) {
    link.href = `/manifest${filePostfix}.json`;
  }
};
